export default __webpack_public_path__ + "static/externalImg2-2982d307354dff3d65c4e089c8a8c973.webp";